import { Provider } from "react-redux";
import "./App.css";
import { MapPage } from "./pages/map";
import { store } from "./store/store";

function App() {
  return (
    <Provider store={store}>
      <div className="App">
        <MapPage />
      </div>
    </Provider>
  );
}

export default App;
